import { SVGProps } from "react";

export function UploadIcon({
  size = 42,
  color = "currentColor",
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 42 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props as any)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 28.0635C21.3481 28.0635 21.682 27.9252 21.9281 27.6791C22.1742 27.4329 22.3125 27.0991 22.3125 26.751V7.54823L25.2525 10.98C25.479 11.2445 25.8013 11.4083 26.1486 11.4352C26.4958 11.4621 26.8395 11.35 27.104 11.1235C27.3686 10.897 27.5323 10.5747 27.5592 10.2274C27.5861 9.88022 27.474 9.53653 27.2475 9.27198L21.9975 3.14698C21.8743 3.00289 21.7213 2.88721 21.5491 2.80789C21.3769 2.72857 21.1896 2.6875 21 2.6875C20.8104 2.6875 20.6231 2.72857 20.4509 2.80789C20.2787 2.88721 20.1257 3.00289 20.0025 3.14698L14.7525 9.27198C14.6404 9.40297 14.5551 9.55477 14.5016 9.71871C14.4482 9.88265 14.4275 10.0555 14.4408 10.2274C14.4541 10.3994 14.5012 10.567 14.5793 10.7207C14.6574 10.8745 14.765 11.0113 14.896 11.1235C15.027 11.2356 15.1788 11.3209 15.3428 11.3744C15.5067 11.4278 15.6796 11.4485 15.8515 11.4352C16.0234 11.4219 16.191 11.3748 16.3448 11.2967C16.4985 11.2186 16.6354 11.111 16.7475 10.98L19.6875 7.54998V26.751C19.6875 27.4755 20.2755 28.0635 21 28.0635Z"
        fill={color}
      />
      <path
        d="M28 16.25C26.7715 16.25 26.1573 16.25 25.7145 16.5457C25.5241 16.6731 25.3606 16.8366 25.2332 17.027C24.9375 17.4698 24.9375 18.084 24.9375 19.3125V26.75C24.9375 27.7943 24.5227 28.7958 23.7842 29.5342C23.0458 30.2727 22.0443 30.6875 21 30.6875C19.9557 30.6875 18.9542 30.2727 18.2158 29.5342C17.4773 28.7958 17.0625 27.7943 17.0625 26.75V19.3125C17.0625 18.084 17.0625 17.4698 16.7668 17.027C16.6394 16.8366 16.4759 16.6731 16.2855 16.5457C15.8427 16.25 15.2285 16.25 14 16.25C9.051 16.25 6.57475 16.25 5.03825 17.7882C3.5 19.3247 3.5 21.7975 3.5 26.7482V28.4982C3.5 33.4507 3.5 35.9235 5.03825 37.4618C6.57475 39 9.051 39 14 39H28C32.949 39 35.4253 39 36.9618 37.4618C38.4982 35.9235 38.5 33.449 38.5 28.5V26.75C38.5 21.7993 38.5 19.3247 36.9618 17.7882C35.4253 16.25 32.949 16.25 28 16.25Z"
        fill={color}
      />
    </svg>
  );
}
